import React from 'react';

function EdgeSection() {
    const edges = [
        {
            icon: '🔄',
            title: 'Connected Strategy',
            description: 'Guest sentiment from reviews informs our content strategy. Booking patterns shape our outreach priorities. Staff feedback influences our recruiting approach. Everything connects.'
        },
        {
            icon: '⚙️',
            title: 'Coordinated Response',
            description: 'When occupancy drops, we launch campaigns. When turnover spikes, we accelerate recruiting. When direct bookings surge, we double down. One team, coordinated action.'
        },
        {
            icon: '🎨',
            title: 'Brand Consistency',
            description: 'One voice across every channel. Your dedicated team learns your tone, your values, your personality then maintains it consistently across 10,000+ monthly touchpoints.'
        },
        {
            icon: '💰',
            title: 'Radical Cost Savings',
            description: 'Replace 7 vendor invoices with one flat fee. Cut OTA commissions by 30%. Reduce turnover costs by half. Average savings: $127K annually.'
        },
        {
            icon: '🧠',
            title: 'Continuous Improvement',
            description: 'Every interaction makes us better. Guest preferences, market trends, staff patterns your team continuously refines strategy based on real performance data.'
        },
        {
            icon: '🛡️',
            title: 'Single Point of Accountability',
            description: 'No more vendor blame games. One team. One partner. One promise. If something breaks, we fix it. Period.'
        }
    ];

    return (
        <section className="edge-section">
            <div className="section-content">
                <h2 className="section-title" style={{ color: '#ffffff' }}>
                    Why <span className="highlight">One Partner</span> Changes Everything
                </h2>
                <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.95)', maxWidth: '800px', margin: '0 auto 3rem' }}>
                    Other companies sell you pieces. We give you the complete team that works together, thinks together, and wins together.
                </p>
                <div className="edge-grid">
                    {edges.map((edge, index) => (
                        <div key={index} className="edge-card">
                            <div className="edge-icon">{edge.icon}</div>
                            <h3 className="edge-title">{edge.title}</h3>
                            <p>{edge.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default EdgeSection;

